import { Directive, ElementRef, OnInit, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[dynamicId]',
  standalone: false
})
export class DynamicIdDirective implements OnInit {
  @Input('dynamicId') inputControlName: string;
  static idCounter = 0;

  constructor(private renderer: Renderer2, private el: ElementRef) {}

  ngOnInit() {
    const uniqueId = `${this.inputControlName}-${DynamicIdDirective.idCounter++}`;
    this.renderer.setAttribute(this.el.nativeElement, 'id', uniqueId);
  }
}
